export default __webpack_public_path__ + "static/6-implant-96395dc247021ace66cf775c8f3c5242.png";